module.exports = __webpack_public_path__ + "img/wizard_chess.36307c65.jpg";